// extracted by mini-css-extract-plugin
export default {"inputholder":"Feedback_inputholder__-lA9+","inputbox":"Feedback_inputbox__VZNxo","save":"Feedback_save__mfRzC","cancel":"Feedback_cancel__K7FWI"};